






export default {
  name: 'sideways-label'

  props:
    label:
      type: String
      required: true
    color:
      type: String
      required: false
      default: 'white'
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/generic/SidewaysLabel.vue